/*
 *
 * ClientsDetail
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 25-Feb-2025
 */

import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import Dialog from '@mui/material/Dialog'
import FlowTemplate from 'Components/Template/FlowTemplate'
import PortalTabs from '@nexidigital/portaltabs'
import ClientFirstPeriodDetail from './ClientFirstPeriodDetail'
import ClientSecondPeriodDetail from './ClientSecondPeriodDetail'
import { useMobileDetect } from 'Hoc/ListenerProvider'
import { Dismiss } from '@nexidigital/iconlibrary'
import formattedMessage from './languageModule'
import PortalLoader from '@nexidigital/portalloader'
import './ClientsDetail.scss'

const ClientsDetail = ({ actions, open, tabSelected, clientsDetails, referredPeriod, isClientsDetailsLoading, lastAppliedParams }) => {
  const { isSmallScreen } = useMobileDetect()
  const hasLoadedDetails = useRef(false)

  // Carica i dettagli solo quando il popup si apre per la prima volta
  useEffect(() => {
    if (open && !hasLoadedDetails.current && lastAppliedParams) {
      hasLoadedDetails.current = true
      actions.doGetTotalClientsDetails(lastAppliedParams)
    }

    // Reset quando il popup si chiude
    if (!open) {
      hasLoadedDetails.current = false
    }
  }, [open, lastAppliedParams])

  // Nullsafe: verifica che clientsDetails e i suoi periodi esistano
  const firstPeriod = clientsDetails?.firstPeriod || {}
  const secondPeriod = clientsDetails?.secondPeriod || {}

  const tabData = [
    {
      label: formattedMessage.tabData1,
      content: <ClientFirstPeriodDetail referredPeriod={referredPeriod} recurringClients={firstPeriod.regularCustomers || {}} newClients={firstPeriod.newCustomers || {}} />
    },
    {
      label: formattedMessage.tabData2,
      content: <ClientSecondPeriodDetail referredPeriod={referredPeriod} recurringClients={secondPeriod.regularCustomers || {}} newClients={secondPeriod.newCustomers || {}} />
    }
  ]

  return (
    <Toggle>
      <Dialog fullScreen open={open} className='clientsDetailDialog'>
        <FlowTemplate
          flowBackground
          titleNavigation={formattedMessage.titleNavigation}
          iconCloseRight={<Dismiss size={isSmallScreen ? '24' : '20'} type='line' />}
          labelButtonRightNav={formattedMessage.close}
          onClickClose={() => actions.doClosePopup()}
          emptyPage
        >
          <sector className='clientsDetail'>
            {isClientsDetailsLoading
              ? (
                <PortalLoader circular centered />
                )
              : (
                  tabSelected === 'TWO_PERIODS'
                    ? (
                      <PortalTabs merchant tabData={tabData} />
                      )
                    : (
                      <ClientFirstPeriodDetail referredPeriod={referredPeriod} recurringClients={firstPeriod.regularCustomers || {}} newClients={firstPeriod.newCustomers || {}} />
                      )
                )}
          </sector>
        </FlowTemplate>
      </Dialog>
    </Toggle>
  )
}

ClientsDetail.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  actions: PropTypes.object,
  /** This props is used to open the dialog */
  open: PropTypes.bool,
  /** This props is used to get the current tab of results */
  tabSelected: PropTypes.string,
  clientsDetails: PropTypes.object,
  referredPeriod: PropTypes.arrayOf(PropTypes.string),
  isClientsDetailsLoading: PropTypes.bool,
  lastAppliedParams: PropTypes.object
}

ClientsDetail.defaultProps = {
  // Add here some default propTypes values
  actions: {},
  open: false,
  tabSelected: 'ONE_PERIOD',
  clientsDetails: {},
  referredPeriod: [],
  isClientsDetailsLoading: false,
  lastAppliedParams: null
}

export default ClientsDetail
